import { render, staticRenderFns } from "./DeferredImg.vue?vue&type=template&id=82e7276e&"
import script from "./DeferredImg.vue?vue&type=script&lang=js&"
export * from "./DeferredImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports